import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import Dashboard from '../components/Menu/Dashboard';
import TaxeRenderBody from '../components/Taxes/TaxeRenderBody';
import ElectricTaxeForm from '../components/Taxes/ElectricTaxeForm';
import TaxePanel from '../components/Taxes/TaxePanel';
import MeterInfoPanel from '../components/Taxes/MeterInfoPanel';
import { getMeterCore, createMeterCore, getMetersList, processMeterPayment, createProcessMeterCode } from './../actions/metersCore'
import { createCodeMeter } from './../actions/codes'
import { connect } from "react-redux";
import {  Button } from '@material-ui/core';
import StandardList from '../components/Complements/StandardList';
import StandardDialog from '../components/Complements/StandardDialog';
import DescriptionFormRedux from '../components/Complements/DescriptionForm';
import DialogOTP from '../components/Complements/DialogOTP';
import { osName, osVersion, isMobile } from 'react-device-detect';
import { findDataInArrayStore, validateIp } from '../functions/store';
import UserPanelInfoMobile from '../components/Complements/UserPanelInfoMobile';
import LoadingScreen from '../components/Complements/LoadingScreen';
import { setCodesOTP } from '../functions/core-actions';
import { filterArrayEqual, isEmpty } from '../functions/arrays';
import { history } from '../helpers/history';
import Voucher from '../components/Transfers/Voucher';
import { sendEmailWithVoucher } from "./../actions/sendEmailWithVoucher";
import { urlVoucher } from '../services/urls';
import moment from 'moment';
import MessageInfo from '../components/Complements/MessageInfo';
import { changeStatusUser } from './../actions/codes'
import { sendLogs } from '../functions/function-logs';
import { getBalanceUser } from "./../actions/balances";
import { sendMobile } from '../functions/mobile';
import { feathersCreateData } from '../services';
import { handleDownloadMovil, handleDownloadWeb } from '../functions/handle-download';

const ElectricTaxeContainer = props => {
    const { user, balances, companies, getMeterCore, handleOpenSnack, createCodeMeter, getMetersList,
            createMeterCore, auth, meters, processMeterPayment, createProcessMeterCode, sendEmailWithVoucher, getDeviceData, updateIpDevice, devices } = props
    const [ accountSelected, setAccountSelected ] = useState(balances[0])
    const [ show, setShow ] = useState(false)
    const [ showvoucher, setShowvoucher ] = useState(false)
    const [ dataresponse, setDataresponse ] = useState({})
    const [ select, setSelect ] = useState(true)
    const [ openDialog, setOpenDialog ] = useState(false)
    const [ openDialogOTP, setOpenDialogOTP ] = useState(false)
    const [ loading, setLoading ] = useState(false)
    const [ favorites, setFavorites ] = useState(true)
    const [ OTPId, setOTPId ] = useState(0)
    const [ contAttemptsCreateMeter, setcontAttemptsCreateMeter ] = useState(0)
    const [ contAttemptsMeterProcess, setcontAttemptsMeterProcess ] = useState(0)
    const [ codeOTP, setCodeOTP ] = useState('')
    const [ OTPType, setOTPType ] = useState('')
    const [ dialogTitle, setDialogTitle ] = useState('')
    const [ dialogContent, setDialogContent ] = useState(<div></div>)
    const [meterInfo, setMeterInfo ] = useState({})
    const [meterList, setMeterList ] = useState([])
    const [ showDialogAccounts, setShowDialogAccounts ] = useState(false)
    const [ dataList ] = useState([
        {id: '1', primary: 'Seleccione Medidor', secondary: '', icon: 'account_balance_wallet' },
        {id: '2', primary: 'Buscar Medidor', secondary: '', icon: 'search'}
    ])
    const [ formTaxe, setFormTaxe ] = useState({
        company: companies[0],
        code: '',
        concept: '',
        description: ''
    })
    // carga inicial
    useEffect ( ( )  =>  {
        const { id } = auth
        getMetersList(id).then(res=> {
            if(res.payload.length === 0) 
                { handleOpenSnack('No existen medidores.', 'info') } else 
                {   setMeterList(res.payload) }
        }).catch(err => {/* console.log(err) */})
    }, [auth, handleOpenSnack, getMetersList])
    
    // funtions

    const handleSetNewPayment = () => {
        setShowvoucher(false)
        setDataresponse({})
    }

    const handleAccountChange = () => {
        setShowDialogAccounts(!showDialogAccounts)
    }

    const handleChangeInputOtp = (valueinput) => {
        if(valueinput.toString().length === 4){
            handleOTPCompare({data : valueinput.toString()});
        }

    }

    const handleSendEmailWithVoucher = () => {

        setLoading(true)

        const { CorreoElectronico } = user;

        const { DocumentoTransaccion } = dataresponse;

        let object_send_email_with_voucher = {
            Documento : "voucher_"+DocumentoTransaccion,
            Email : CorreoElectronico 
        }

        sendEmailWithVoucher(object_send_email_with_voucher).then(
            response => {

                const { message, type } = response.payload;

                setLoading(false)

                handleOpenSnack(message, type);
            }
        ).catch(
            error => {
                setLoading(false)
                handleOpenSnack('No se ha enviado correctamente el comprobante. Por favor vuelva a intentar.', 'error')
            }
        )
    }

    const handleCancelTransferForm = () => {
        history.push('/')
    }

    const handleDownloadVoucher = () => {
        feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataresponse.DocumentoTransaccion, name_voucher: dataresponse.name_voucher})().then(res => {
            if (res.error) {
                handleOpenSnack(res.message, 'error')
            } else {
                if (localStorage.caja_app !== undefined) {
                    // let send = {
                    //     type: 'action',
                    //     action: 'download_voucher',
                    //     data: urlVoucher+res.voucher+".pdf",
                    //     messageSend: 'Comprobante'
                    // }
                    // sendMobile(JSON.stringify(send))
                    handleDownloadMovil(urlVoucher, res.voucher)
                    
                } else {
                    // window.open(urlCertificates+nameFile+".pdf", '_blank');
                    handleDownloadWeb(urlVoucher, res.voucher)
                }
            }
        }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
        
    }

    const handleChangeStatusUser = () => {

        setLoading(true)

        props.changeStatusUser({emited : "NAVCHANGESTATUS", iduser : auth.id}).then(
            response => {
                setLoading(false)
            }
        ).catch(
            error => {
                setLoading(false)
            }
        )
    }

    const handleValidateAttemptsOtp = (cont, typeproccess) => {

        const { parameters, devices, getDeviceData } = props

        let contAttemptsAllowed = (parameters.length > 0) ? filterArrayEqual(parameters, 'name', 'OTP_TRY')[0].value : 5

        cont++;

        switch (typeproccess) {
            case 'CREATEMETER':
                setcontAttemptsCreateMeter(cont)
                break;
            case 'METER_PROCESS':
                const {company, code, description } = formTaxe
                const { MontoPagar, MontoComision} = meterInfo
                sendLogs(auth.vusk, {
                    CodigoMedidor: code,
                    SecuencialEmpresaElectrica: company.Secuencial,
                    SecuencialEmpresa: 1,
                    SecuencialCuenta:accountSelected.Secuencial,
                    Concepto: description,
                    MontoPagar,
                    MontoComision,
                    NumeroCuentaOrigen : accountSelected.Codigo
                }, 16, devices, getDeviceData)
                setcontAttemptsMeterProcess(cont)
                break;
            default:
                break;
        }

        if(cont > contAttemptsAllowed){
            setOpenDialogOTP(false)
            handleChangeStatusUser()
            handleOpenSnack('Se ha excedido el número de intentos permitidos. Por favor contáctese con COOPERATIVA CAJA llamando al 0958882285.', 'error');
        }
        
    }

    const handleOpenFavorites = () => {
        setDialogTitle('Ingrese descripción del Medidor')
        setDialogContent(
            <DescriptionFormRedux
                label="Concepto"
                positive = {'Aceptar'}
                onSubmit = {
                    (concept) => {
                        setFormTaxe(prevState => ({
                            ...prevState,
                            concept: concept.data
                        }))
                        setOpenDialog(false)
                        createCodeMeter({emited: 'NAVCREATEMETERREQUEST', type: 15, deviceData: `${osName} ${osVersion}` })
                        .then(res => {
                            const {result, data} = res.payload
                            setCodeOTP('' + result)
                            setOTPId(data.sequence)
                            setOTPType('CREATEMETER')
                            setOpenDialogOTP(true)
                        }).catch(err=> {
                            //console.log('error de OTP', err)
                            handleOpenSnack('Error al solicitar OTP', 'error')
                        })
                        
                    }
                }
            />
        )
        setOpenDialog(true)
    }
    const handleMeterProcess = async(description) => {
        try {
            setLoading(true)
            setFormTaxe({
                ...formTaxe,
                description: description.data
            })
            const { ip } = devices
            let ipSend = await validateIp(ip, getDeviceData, updateIpDevice)
            createProcessMeterCode({emited: 'NAVCREATECODE', type: 16, deviceData: `${osName} ${osVersion}`, ip: ipSend })
            .then(({payload}) => {
                const { result, data } = payload
                //console.log(payload)
                setOTPId(data.sequence)
                setCodeOTP(''+result)
                setOTPType('METER_PROCESS')
                setOpenDialogOTP(true)
                setLoading(false)
            }).catch(err => {
                setLoading(false)
                handleOpenSnack('No se ha podido realizar la transacción. Por favor intente nuevamente.', 'error')
            })
        } catch (error) {
            //console.log(error)
            setLoading(false)
        }
        
    }
    const handleListSelected = (val) => {
        const { id } = val
        if (id === '1') {
            setDialogContent(
                <div>
                    <StandardList 
                    dataList={ meterList }
                    primary={'code'}
                    secondary = { 'description'}
                    icon = { 'flash_on'}
                    selectItem = { handleMeterSelected }
                    />
                    <Button 
                    fullWidth
                    variant="contained"
                    color="primary" onClick = {() => setOpenDialog(false)}>Cancelar</Button>
                </div>
            )
            setDialogTitle('Seleccione Medidor')
            setOpenDialog(true)
        } else {
            setSelect(false)
            setShow(true)
        }
        
    }
    const handleCloseDialog = (value) => {
        setOpenDialog(false)
    }

    const handleUpdatedBalances = async() => {
        await props.getBalanceUser({NumeroCliente: user.NumeroCliente, SecuencialEmpresa: 1, EstaActiva: true}).then( res => {
            
            const { data } = res.payload;
            const getdataaccountselected = data.filter(item => {
                return (item.Secuencial === accountSelected.Secuencial) ? true : false;
                
            })

            setAccountSelected(getdataaccountselected[0])

        })
        .catch(err=> {
            //console.log(' error al obtener balances ', err)
        })
    }
    
    const handleSubmit = (data) => {
        try {
            setLoading(true)
            const meterExist = findDataInArrayStore(meters, 'code', data.code)
            if (meterExist === undefined ) {
                getMeterCore({SecuencialEmpresaElectrica: formTaxe.company.Secuencial, CodigoMedidor: data.code})
                .then(res => {
                    const { data } = res.payload
                    if(data.NumeroMedidor !== '005') {
                        setShow(false)
                        setFavorites(true)
                        setMeterInfo(res.payload.data)
                        setLoading(false)
                        setFormTaxe({
                            ...formTaxe,
                            code: res.payload.data.NumeroMedidor
                        })
                    } else {
                        setLoading(false)
                        handleOpenSnack('Medidor no encontrado.', 'error')
                    }
                    
                }).catch(err => {
                    setLoading(false)
                    handleOpenSnack('Medidor no encontrado.', 'error')
                    //console.log('error al buscar medidor ', err)
                })
            } else {
                setLoading(false)
                handleOpenSnack('El medidor ya se encuentra agregado.', 'info')
            }
        } catch (error) {
            setLoading(false)
        }
    }
    const handleOTPCompare = ({data}) => {
        const { id } = auth
        setLoading(true)
        if (OTPType === 'CREATEMETER') {
            if (codeOTP === data) {
                const {code, concept, company} = formTaxe
                setCodesOTP(OTPId, 'v' ).then(res => {})
                createMeterCore({
                    emited: 'NAVCREATEMETER',
                    id: OTPId,
                    code,
                    description: concept,
                    company: company.Secuencial,
                    user: id
                }).then(({payload}) => {
                    setLoading(false)
                    const {alert, type} = payload
                    setOpenDialogOTP(false)
                    setSelect(true)
                    setShow(true)
                    handleOpenSnack(alert, type)
                }).catch( err => {
                    setLoading(false)
                    //console.log(err)
                    handleOpenSnack('Error al agregar medidor', 'error')
                })
            } else {
                setLoading(false)
                handleOpenSnack('El código OTP no es correcto. Por favor intente nuevamente.', 'error')
                handleValidateAttemptsOtp(contAttemptsCreateMeter, 'CREATEMETER')
            }
        } else if (OTPType === 'METER_PROCESS') {
            try {
                
                if (codeOTP === data) {
                    // setCodesOTP(OTPId, 'v' ).then(res => {})
                    const {company, code, description } = formTaxe
                    const { MontoPagar, MontoComision} = meterInfo
                    processMeterPayment({
                        CodigoMedidor: code,
                        SecuencialEmpresaElectrica: company.Secuencial,
                        SecuencialEmpresa: 1,
                        SecuencialCuenta:accountSelected.Secuencial,
                        Concepto: description,
                        MontoPagar,
                        MontoComision,
                        NumeroCuentaOrigen : accountSelected.Codigo,
                        otpId: OTPId
                    }).then( ({payload}) => {
                        handleUpdatedBalances()
                        const {error, data} = payload
                        setShowvoucher(true);
                        setDataresponse(data);
                        setLoading(false)
                        if (!error) {
                            setOpenDialogOTP(false)
                            handleOpenSnack('El pago del medidor ha sido realizado.', 'success')
                        } else {
                            handleOpenSnack('Ha ocurrido un error en la transacción. Por favor intente nuevamente.', 'error')
                        }
                        
                    }).catch(err =>{
                        setLoading(false);
                        setShowvoucher(false);
                        handleOpenSnack('Ha ocurrido un error en la transacción. Por favor intente nuevamente.', 'error')
                    })
                } else {
                    setLoading(false)
                    handleOpenSnack('El código OTP no es correcto. Por favor intente nuevamente.', 'error')
                    handleValidateAttemptsOtp(contAttemptsMeterProcess, 'METER_PROCESS')
                }
            } catch (error) {
                handleOpenSnack('Ha ocurrido un error en la transacción. Por favor intente nuevamente.', 'error')
            }
            
        }
        
    }
    const handleMeterSelected = (val) => {
        const {company, code } = val
        getMeterCore({SecuencialEmpresaElectrica: company, CodigoMedidor: code})
        .then(res => {
            setShow(false)
            setSelect(false)
            setOpenDialog(false)
            // para deshabilitar boton favoritos
            setFavorites(false)
            setMeterInfo(res.payload.data)
            setFormTaxe({
                ...formTaxe,
                code: res.payload.data.NumeroMedidor
            })
            // console.log('encuentra medidor ', res.payload)
        }).catch(err => {
            handleOpenSnack('Medidor no encontrado.', 'error')
            //console.log('error al buscar medidor ', err)
        })
    } 
    // renders
    const renderProcess = () => {
        if (show) {
            return  <ElectricTaxeForm
                        companies = { companies }
                        formTaxe = { formTaxe }
                        setFormTaxe = { setFormTaxe }
                        onSubmit = { handleSubmit } 
                        onCancelAction = { () => { setSelect(true) }} /> 
        } else {
            return  <div>
                        <MeterInfoPanel 
                            data = { meterInfo }
                            openFavorites = { handleOpenFavorites }
                            favorites = {favorites}
                            submitMeterProcess = { handleMeterProcess }
                            onCancelAction = {() => { setSelect(true) }}
                        />
                    </div>
        }
    }
    const renderBody = () => {
        if (isMobile) {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio.'} />
            } else {
                return  <div>
                            <UserPanelInfoMobile
                                user = { user }
                                balances = { balances } 
                                accountSelected = { accountSelected }
                                changeAccount = { setAccountSelected } 
                                handleAccountChange = {handleAccountChange}
                                dialog = {showDialogAccounts}
                            >
                                    { select ? 
                                        <StandardList 
                                            dataList={ dataList }
                                            primary={'primary'}
                                            secondary = { 'secondary'}
                                            selectItem = { handleListSelected }
                                        /> :
                                        (showvoucher === false) ? renderProcess() :
                                        <Voucher 
                                            amount = { dataresponse.MontoPagar }
                                            titleheader = { "Valor Cancelado" }
                                            titlebuttonnew = { "Nuevo Pago" }
                                            titleone = { "" }
                                            titletwo = { "" }
                                            databodytwo = { [] }
                                            databodyone = {
                                                            [
                                                                {
                                                                    title : "Servicio",
                                                                    value : "Luz",
                                                                    order : 1
                                                                },
                                                                {
                                                                    title : "Institución",
                                                                    value : dataresponse.NombreInstitucion,
                                                                    order : 2
                                                                },
                                                                {
                                                                    title : "Nro. medidor",
                                                                    value : "# "+dataresponse.NumeroMedidor,
                                                                    order : 3
                                                                },
                                                                {
                                                                    title : "Propietario",
                                                                    value : dataresponse.NombreCliente,
                                                                    order : 4
                                                                },
                                                                {
                                                                    title : "Fecha de pago",
                                                                    value : moment(dataresponse.FechaPago).format('DD/MM/YYYY'),
                                                                    order : 5
                                                                },
                                                                {
                                                                    title : "Dcto. de transacción",
                                                                    value : "# "+dataresponse.DocumentoTransaccion,
                                                                    order : 6
                                                                }
                                                            ]
                                                        }
                                            typesizegrid = {6}
                                            handleSendEmailWithVoucher = { handleSendEmailWithVoucher }
                                            handleCancelTransferForm = { handleCancelTransferForm }
                                            onActionAfter = { handleSetNewPayment }
                                            handleDownloadVoucher = { handleDownloadVoucher }
                                            handleDownloadDevice = { () => {
                                                try {
                                                    feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataresponse.DocumentoTransaccion, name_voucher: dataresponse.name_voucher})().then(res => {
                                                        if (res.error) {
                                                            handleOpenSnack(res.message, 'error')
                                                        } else {
                                                            let send = {
                                                                type: 'action',
                                                                action: 'export_voucher',
                                                                data: urlVoucher+res.voucher+".pdf",
                                                                nameFile: res.voucher,
                                                                extension: 'pdf',
                                                                messageSend: 'Pago de Medidor'
                                                            }
                                                            sendMobile(JSON.stringify(send))
                                                        }
                                                    }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                                } catch (error) {
                                                    //console.log(error)
                                                }
                                            }}
                                        />
                                    }
                            </UserPanelInfoMobile>
                            <StandardDialog
                                open = {openDialog}
                                title = {dialogTitle}
                                handleClose = { handleCloseDialog } >
                                    {dialogContent}
                            </StandardDialog>
                            <DialogOTP
                                openDialogOTP= { openDialogOTP }
                                onCloseDialogOTP = { () => setOpenDialogOTP(false)}
                                initialTime = { Date.now()}
                                showQR = {false}
                                loading = {loading}
                                OTPSubmit = { handleOTPCompare }
                                handleChangeInputOtp = { handleChangeInputOtp }
                            />
                    </div>
            }
        } else {
            if (isEmpty(accountSelected)) {
                return <MessageInfo type='info' text={'No dispone de una cuenta para el pago de este servicio'} />
            } else {
                return  <TaxeRenderBody
                        user = { user }
                        balances = { balances } 
                        accountSelected = { accountSelected }
                        changeAccount = { setAccountSelected } >
                        
                        <TaxePanel>
                            { select ? 
                                <StandardList 
                                    dataList={ dataList }
                                    primary={'primary'}
                                    secondary = { 'secondary'}
                                    selectItem = { handleListSelected }
                                /> :
                                (showvoucher === false) ? renderProcess() :
                                <Voucher 
                                        amount = { dataresponse.MontoPagar }
                                        titleheader = { "Valor Cancelado" }
                                        titlebuttonnew = { "Nuevo Pago" }
                                        titleone = { "" }
                                        titletwo = { "" }
                                        databodytwo = { [] }
                                        databodyone = {
                                                        [
                                                            {
                                                                title : "Servicio",
                                                                value : "Luz",
                                                                order : 1
                                                            },
                                                            {
                                                                title : "Institución",
                                                                value : dataresponse.NombreInstitucion,
                                                                order : 2
                                                            },
                                                            {
                                                                title : "Nro. medidor",
                                                                value : "# "+dataresponse.NumeroMedidor,
                                                                order : 3
                                                            },
                                                            {
                                                                title : "Propietario",
                                                                value : dataresponse.NombreCliente,
                                                                order : 4
                                                            },
                                                            {
                                                                title : "Fecha de pago",
                                                                value : moment(dataresponse.FechaPago).format('DD/MM/YYYY'),
                                                                order : 5
                                                            },
                                                            {
                                                                title : "Dcto. de transacción",
                                                                value : "# "+dataresponse.DocumentoTransaccion,
                                                                order : 6
                                                            }
                                                        ]
                                                    }
                                        typesizegrid = {6}
                                        handleSendEmailWithVoucher = { handleSendEmailWithVoucher }
                                        handleCancelTransferForm = { handleCancelTransferForm }
                                        onActionAfter = { handleSetNewPayment }
                                        handleDownloadVoucher = { handleDownloadVoucher }
                                        handleDownloadDevice = { () => {
                                            try {
                                                feathersCreateData('voucher-document', { name:accountSelected.Codigo, document: dataresponse.DocumentoTransaccion, name_voucher: dataresponse.name_voucher})().then(res => {
                                                    if (res.error) {
                                                        handleOpenSnack(res.message, 'error')
                                                    } else {
                                                        let send = {
                                                            type: 'action',
                                                            action: 'export_voucher',
                                                            data: urlVoucher+res.voucher+".pdf",
                                                            nameFile: res.voucher,
                                                            extension: 'pdf',
                                                            messageSend: 'Pago de Medidor'
                                                        }
                                                        sendMobile(JSON.stringify(send))
                                                    }
                                                }).catch(err => handleOpenSnack('No se ha encontrado el documento', 'error') )
                                            } catch (error) {
                                                //console.log(error)
                                            }
                                        }}
                                    />
                            }
                        </TaxePanel>
                        <StandardDialog
                            open = {openDialog}
                            title = {dialogTitle}
                            handleClose = { handleCloseDialog } >
                                {dialogContent}
                        </StandardDialog>
                        <DialogOTP
                            openDialogOTP= { openDialogOTP }
                            onCloseDialogOTP = { () => setOpenDialogOTP(false)}
                            initialTime = { Date.now()}
                            showQR = {false}
                            loading = {loading}
                            OTPSubmit = { handleOTPCompare }
                            handleChangeInputOtp = { handleChangeInputOtp }
                        />
                    </TaxeRenderBody>
            }
            
        }
        
    }
    return (
        <div>
            <Dashboard
                title= "Dashboard"
                body = { renderBody() }
                multiple = { false }
            />
            <LoadingScreen open = {loading} />
        </div>
    );
};

ElectricTaxeContainer.propTypes = {
    handleOpenSnack: PropTypes.func.isRequired,
    user: PropTypes.object.isRequired,
    balances: PropTypes.array.isRequired,
    companies: PropTypes.array.isRequired,
    meters: PropTypes.array.isRequired,
};

export default connect(null, {
    getMeterCore,
    createCodeMeter,
    createMeterCore,
    getMetersList,
    processMeterPayment,
    createProcessMeterCode,
    sendEmailWithVoucher,
    changeStatusUser,
    getBalanceUser
} )(ElectricTaxeContainer)
// export default ElectricTaxeContainer;